import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import JobsListSaved from './JobsListSaved';
import { Pagination, Loader } from '../../../../common/elements';
import { NetworkHelpers as Network, PaginationHelpers as Page } from '../../../../../helpers/';
import * as jobsActions from '../../../../../actions/jobs/jobs';
import { Link } from 'react-router';
import {siteOfOriginHelper} from '../../../../../../client/helpers/genericHelpers';

class JobFavourites extends Component {

    componentWillMount() {
        const { location, options, getFavouriteJobs } = this.props;

        const page = location.query.page;

        getFavouriteJobs(options, page ? page : 1, localStorage.getItem('person_id'));
    };

    componentWillReceiveProps(nextProps) {

        const { favouriteJobs, location, options, getFavouriteJobs } = this.props;

        if (favouriteJobs !== nextProps.favouriteJobs) {

            const page = location.query.page;
            if (favouriteJobs.length > 0 && favouriteJobs !== 'load' && nextProps.favouriteJobs !== 'load') {
                nextProps.favouriteJobs.map((job, index) => {

                    if (job.favourite !== favouriteJobs[index].favourite) {
                        getFavouriteJobs(options, page ? page : 1, localStorage.getItem('person_id'));
                    }

                });
            }

        }

    }

    addJobToFavourites = (jobId, index) => {

        const { addJobToFavourites } = this.props;

        addJobToFavourites(localStorage.getItem('person_id'), jobId, index);

    };

    removeJobFromFavourites = (jobId, index) => {

        const { removeJobFromFavourites } = this.props;

        removeJobFromFavourites(localStorage.getItem('person_id'), jobId, index);

    };

    getNextJobs(pageId) {
        const { getFavouriteJobs, options } = this.props;

        getFavouriteJobs(options, pageId, localStorage.getItem('person_id'));
        browserHistory.push(`/my-jobs-section/favourite-jobs?page=${pageId}#topoflist`);
    }

    render() {
        const { paging, favouriteJobs, location } = this.props,
            pageLocation = location.query ? location.query.page : 1;

        const totalPages = paging && paging.total_pages,
            currentPage = Page.setCurrentPage(pageLocation, totalPages),
            pagination_details = Page.getCurrentPage(currentPage, totalPages),
            pageNumbers = Page.getPageNumbers(pagination_details),
            permissions = Network.getProductPermissions(2);

        const siteOfOrigin = siteOfOriginHelper();

        return (
            <div className="main__content">
            <h1 className="h1">{ siteOfOrigin !== 'us' ? `${'Favourite'}` : `${'Favorite'}`} Jobs</h1>
                <section className="section jobs-body__saved">
                    {
                        favouriteJobs === 'load' ?
                            (
                                <Loader />
                            )
                            :
                            (
                                favouriteJobs.length === 0 ?
                                    <div className="message-no-results">
                                        <h4 className="h4">You don't currently have any favourites jobs.</h4>
                                        <p className="p-tag">To find more opportunities go to go to Jobs Board or click the button below:</p>
                                        <Link className="btn btn-primary"
                                            to={`/jobs`}>
                                            <span className="label">Search for roles</span>
                                        </Link>
                                    </div>
                                    :
                                    <JobsListSaved addJobToFavourites={(jobId, index) => this.addJobToFavourites(jobId, index)} removeJobFromFavourites={(jobId, index) => this.removeJobFromFavourites(jobId, index)} jobs={favouriteJobs} permissions={permissions ? permissions : false} />
                            )
                    }
                    {
                        totalPages > 1 ? (
                            <Pagination
                                currentPage={currentPage}
                                pagination={pagination_details}
                                pageNumbers={pageNumbers}
                                totalPages={totalPages}
                                onPaginationClick={(currentPage) => this.getNextJobs(currentPage)}
                            />
                        ) : ''
                    }
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        favouriteJobs: state.jobs.jobs,
        paging: state.jobs.pagination,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFavouriteJobs: (options, page, personId) => dispatch(jobsActions.getFavouriteJobs(options, page, personId)),
        addJobToFavourites: (personId, jobId, index) => dispatch(jobsActions.addJobToFavourites(personId, jobId, index)),
        removeJobFromFavourites: (personId, jobId, index) => dispatch(jobsActions.removeJobFromFavourites(personId, jobId, index)),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobFavourites);



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobsSavedPage.js